module.exports = __webpack_public_path__ + "img/pay-groups.cb3f0fb9.svg";